import { render, staticRenderFns } from "./TotalDescription.vue?vue&type=template&id=3754c694&scoped=true"
import script from "./TotalDescription.vue?vue&type=script&lang=js"
export * from "./TotalDescription.vue?vue&type=script&lang=js"
import style0 from "./TotalDescription.vue?vue&type=style&index=0&id=3754c694&prod&scoped=true&lang=scss"
import style1 from "./TotalDescription.vue?vue&type=style&index=1&id=3754c694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754c694",
  null
  
)

export default component.exports